<template>
  <div class="admin-home anim-fade-in-up">
    <!-- 欢迎区 -->
    <div class="welcome-card">
      <div class="welcome-left">
        <h1 class="welcome-title">管理后台</h1>
        <p class="welcome-desc">HFLIBS可视化分析系统 · 山东大学行星科学团队</p>
      </div>
      <div class="welcome-right">
        <span class="welcome-date">{{ dateText }}</span>
      </div>
    </div>

    <!-- 统计卡片 — 四列 -->
    <div class="stat-row">
      <div class="stat-card stagger-1" style="animation: fadeInUp 0.4s ease-out both;">
        <div class="stat-num">{{ userCount }}</div>
        <div class="stat-label">系统用户</div>
      </div>
      <div class="stat-card stagger-2" style="animation: fadeInUp 0.4s ease-out both;">
        <div class="stat-num">{{ modelCount }}</div>
        <div class="stat-label">YOLO模型</div>
      </div>
      <div class="stat-card stagger-3" style="animation: fadeInUp 0.4s ease-out both;">
        <div class="stat-num">{{ announcementCount }}</div>
        <div class="stat-label">系统公告</div>
      </div>
      <div class="stat-card stagger-4" style="animation: fadeInUp 0.4s ease-out both;">
        <div class="stat-num">{{ logCount }}</div>
        <div class="stat-label">操作日志</div>
      </div>
    </div>

    <!-- 快捷入口 — 三行两列 -->
    <div class="quick-section">
      <div class="section-label" style="margin-top:0;">
        <span class="rule-line" style="flex:1;"></span>
        <span class="small-caps">Quick Actions</span>
        <span class="rule-line" style="flex:1;"></span>
      </div>
      <div class="quick-grid">
        <div v-for="item in quickItems" :key="item.label" class="quick-item" @click="$router.push(item.path)">
          <i :class="item.icon"></i>
          <span>{{ item.label }}</span>
          <small>{{ item.desc }}</small>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* 欢迎卡片 */
.welcome-card {
  display: flex; align-items: center; justify-content: space-between;
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-card);
  padding: 28px 32px;
  margin-bottom: 24px;
}
.welcome-title {
  font-family: var(--font-display);
  font-size: 1.6rem; font-weight: 600;
  color: var(--text-primary); margin: 0 0 4px;
  letter-spacing: 0.04em;
}
.welcome-desc {
  font-size: 0.84rem; color: var(--text-muted); margin: 0;
}
.welcome-date {
  font-size: 0.82rem; color: var(--text-muted);
  font-family: var(--font-mono);
}

/* 统计卡片行 */
.stat-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
  margin-bottom: 24px;
}
.stat-card {
  text-align: center;
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-card);
  padding: 32px 16px;
  transition: box-shadow var(--transition-base), border-color var(--transition-base);
}
.stat-card:hover {
  box-shadow: var(--shadow-elevated);
  border-color: var(--border-default);
}
.stat-num {
  font-family: var(--font-display);
  font-size: 2.8rem; font-weight: 600;
  color: var(--accent-primary);
  margin-bottom: 6px; line-height: 1.1;
}
.stat-label {
  font-family: var(--font-mono);
  font-size: 0.72rem; color: var(--text-muted);
  text-transform: uppercase; letter-spacing: 0.1em;
}

/* 快捷入口 */
.quick-section {
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-card);
  padding: 24px;
}
.quick-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  margin-top: 20px;
}
.quick-item {
  display: flex; flex-direction: column; align-items: center; gap: 8px;
  padding: 24px 16px;
  border-radius: var(--radius-md);
  background: var(--bg-primary);
  border: 1px solid var(--border-subtle);
  cursor: pointer;
  transition: all var(--transition-base);
  text-align: center;
}
.quick-item:hover {
  border-color: var(--accent-primary);
  box-shadow: var(--shadow-glow-primary);
  transform: translateY(-2px);
}
.quick-item i { font-size: 1.5rem; color: var(--accent-primary); }
.quick-item span { font-size: 0.88rem; color: var(--text-primary); font-weight: 500; }
.quick-item small { font-size: 0.72rem; color: var(--text-muted); }

@media screen and (max-width: 960px) {
  .stat-row { grid-template-columns: repeat(2, 1fr); }
  .quick-grid { grid-template-columns: repeat(2, 1fr); }
}
@media screen and (max-width: 540px) {
  .stat-row { grid-template-columns: 1fr; }
  .quick-grid { grid-template-columns: 1fr; }
  .welcome-card { flex-direction: column; align-items: flex-start; gap: 12px; }
}
</style>

<script>
export default {
  data() {
    return {
      dateText: '',
      userCount: 0,
      modelCount: 0,
      announcementCount: 0,
      logCount: 0,
      quickItems: [
        { icon: 'el-icon-user-solid', label: '成员信息管理', desc: '查看与管理用户', path: '/admin/users' },
        { icon: 'el-icon-cpu', label: 'YOLO模型管理', desc: '上传与管理检测模型', path: '/admin/models' },
        { icon: 'el-icon-view', label: '计算机视觉分析', desc: 'YOLO粒径检测', path: '/admin/vision' },
        { icon: 'el-icon-video-camera', label: '实验视频传输', desc: '实时视频流接收', path: '/admin/video' },
        { icon: 'el-icon-bell', label: '公告管理', desc: '发布与管理公告', path: '/admin/announcement' },
        { icon: 'el-icon-document', label: '系统日志管理', desc: '操作日志与审计', path: '/admin/logs' }
      ]
    }
  },

  created() {
    this.dateText = new Date().toLocaleDateString('zh-CN', { year:'numeric', month:'long', day:'numeric', weekday:'long' });
    this.fetchStats();
  },

  methods: {
    async fetchStats() {
      try {
        const [userR, modelR, annR] = await Promise.all([
          this.$axios.get('/user/list'),
          this.$axios.get('/api/models/list'),
          this.$axios.get('/adm/announcement/list', { params: { page:1, pageSize:1 } })
        ]);
        if (userR.data.code === 0) this.userCount = (userR.data.data || []).length;
        if (modelR.data.code === 0) this.modelCount = (modelR.data.data || []).length;
        if (annR.data.code === 0) this.announcementCount = annR.data.data.total || 0;
      } catch (e) { console.warn(e); }
      try {
        const logR = await this.$axios.get('/adm/logs', { params: { page:1, pageSize:1 } });
        if (logR.data.code === 0) this.logCount = logR.data.data.total || 0;
      } catch (e) { this.logCount = '—'; }
    }
  }
}
</script>
